module.exports = "pegasus_template/assets/blocks/column-5-theme5.png";